/* eslint-disable @typescript-eslint/no-explicit-any */
import { IPickerModel } from '@rhybus/api'
import React, { useEffect, useRef, useState } from 'react'

import { mpfRListsHttp } from '../../../../assets/ts/api/mpf-r-lists-http'
import { mpfWhoHttp } from '../../../../assets/ts/api/mpf-who-http'
import {
  PointsOfContact,
  addOrUpdatePointOfContact
} from '../../../../assets/ts/data/points-of-contact'
import { scrollToTop } from '../../../../assets/ts/general/general'
import Alert from '../../../../components/alert/alert'
import Buttons from '../../../../components/buttons/buttons'
import PageOverlayBusy from '../../../../components/page-overlay/page-overlay-busy'
import { MetadataContextInterface } from '../../../../store/metadata-context-provider'
import {
  ALL_SELECT_LABEL,
  ALL_SELECT_OPTION,
  ALL_SELECT_OPTION_STRING,
  ALL_SELECT_VALUE,
  ALL_SELECT_VALUE_STRING,
  MAX_LENGTHS,
  SELECT_LABEL,
  SELECT_OPTION
} from '../../../../utils/constants/global-constants'
import { NO_CHANGE_MESSAGE } from '../../../../utils/constants/rhybus-config'
import CustomSelect from '../../../../utils/controls/custom-select'
import InputText from '../../../../utils/controls/input-text'
import {
  IsArchived,
  optionsTypes,
} from '../../../../utils/controls/select-options-data'

interface AddEditViewProps {
  assignedComponentOptions: any
  cancel: () => void
  clickedIndex: any
  components: any[]
  fetchPointsOfContact: () => void
  filtersvalue: any[]
  initialMajcomOptions?: any
  initialSectionOptions?: any
  majcoms: any[]
  pointOfContact: any
  pointsOfContact: PointsOfContact[]
  roleContext?: any
  sections: any[]
  showAddPopup: boolean
  visibleSquadrons?: any
}

const AddEditView = ({
  assignedComponentOptions,
  cancel,
  clickedIndex,
  components,
  fetchPointsOfContact,
  filtersvalue,
  initialMajcomOptions,
  initialSectionOptions,
  majcoms,
  pointOfContact,
  pointsOfContact,
  roleContext,
  sections,
  showAddPopup,
  visibleSquadrons
}: AddEditViewProps) => {
  if (showAddPopup) {
    scrollToTop()
  }
  const editPOC = pointOfContact
  const componentOptions = [
    ALL_SELECT_OPTION,
    ...components.map((c) => ({
      label: c.Component,
      value: c.ComponentCode,
    })),
  ]

  const [majcomOptions, setMajcomOptions] = useState<optionsTypes[]>([
    ALL_SELECT_OPTION,
  ])
  const [sectionOptions, setSectionOptions] = useState<Array<optionsTypes>>([ALL_SELECT_OPTION])
  const [squadronOptions, setSquadronOptions] = useState([ALL_SELECT_OPTION_STRING])


  const [peopleDropdownNames, setPeopleDropdownNames] = useState<string[]>([])
  const [peopleExpand, setPeopleExpand] = useState<Array<IPickerModel>>()
  const [selectedValue, setSelectedValue] = useState({
    id: '',
    mailId: '',
    title: '',
  })

  const [inputValues, setInputValues] = useState({
    AssignedComponent: editPOC?.AssignedComponent
      ? editPOC.AssignedComponent
      : ALL_SELECT_LABEL,
    AssignedComponentCode: editPOC?.AssignedComponentCode
      ? editPOC.AssignedComponentCode
      : ALL_SELECT_VALUE,
    DutyTitle: editPOC?.DutyTitle ? editPOC.DutyTitle : '',
    IsArchived: editPOC?.IsArchived ? editPOC.IsArchived : false,
    PhoneNumber: editPOC?.PhoneNumber ? editPOC.PhoneNumber : '',
    PointOfContact: editPOC?.PointOfContact.properties.defaultDisplay
      ? editPOC?.PointOfContact.properties.defaultDisplay
      : '',
      SectionCodeOptions: [],
      SectionCodes: editPOC?.SectionCodes?.length > 0 ?
      editPOC.SectionCodes : [],
    ServicingMAJCOM: editPOC?.ServicingMAJCOM ? editPOC.ServicingMAJCOM : SELECT_LABEL,
    ServicingMAJCOMCode: editPOC?.ServicingMAJCOMCode ? 
      editPOC.ServicingMAJCOMCode : ALL_SELECT_VALUE,
    Squadron: editPOC?.Squadron ?
    editPOC.Squadron : '',
    Title: editPOC?.Title ? editPOC?.Title : '',
  })

  const [POCValidations, setPOCValidations] = useState({
    AssignedComponent: false,
    DutyTitle: false,
    DutyTitleMsg: '',
    MAJCOM: false,
    PhoneNumber: false,
    PhoneNumberMsg: '',
    PointOfContact: false,
    PointOfContactMsg: '',
    Section: false,
  })
  const [showAlert, setShowAlert] = useState(false)
  const [showPageOverlay, setPageOverlay] = useState(false)
  const generateCode = (code: number) => {
    return code > 0 ? code : null
  }

  const handleChange = (key: string, value: boolean | number | string) => {
    setInputValues((prev) => ({
      ...prev,
      [key]: value,
    }))
  }

  const handleChangeNumber = (
    key: string, 
    value: string
  ) => {
    const numberReg = /^[0-9\b]+$/
    if (value === '' || numberReg.test(value)) { 
      setInputValues((prev) => ({
        ...prev,
        [key]: value,
      }))
    }
  }

  const generateMajcomOptions = (
    eValue: string | undefined,
    assignComponents: MetadataContextInterface['components'],
    majcoms: MetadataContextInterface['majcoms']
  ): optionsTypes[] => {
    const defaultOption = ALL_SELECT_OPTION
    if (!eValue) return [defaultOption]
    const componentCode =
      eValue === 'All'
        ? -1
        : assignComponents.find((item) => item.Label === eValue)?.ComponentCode
    if (!componentCode) return [defaultOption]
    const filteredMajcoms = majcoms.filter(
      (item) =>
        componentCode === -1 || item.ParentComponentCode === componentCode
    )
    const mappedOptions = filteredMajcoms.map(({ Label, Value }) => ({
      label: Label,
      value: Value,
    }))
    if (mappedOptions.length > 1) {
      mappedOptions.unshift(defaultOption)
    }
    return mappedOptions
  }

  const getPoCUserData = async (value, firstName) => {
    // TODO - Need to refactor in order to allow the full name
    const userList = [...(await mpfWhoHttp().Picker(firstName))]

    const id = userList.find((item) => item.persona === value)?.rid ?? ''
    const mail = userList.find((item) => item.persona === value)?.email ?? ''
    setSelectedValue({ id: id, mailId: mail, title: value })
  }

  const validateUniquePOC = async (rid: string) => {
    let isValid = false

    const hasPOC: any = pointsOfContact.filter(
      (pocEntry) => pocEntry.PointOfContact.userID === rid
    )

    if (hasPOC.length) {
      const i = hasPOC[0]
      if (
        i.PointOfContact.userID === rid &&
        editPOC?.key &&
        i.eKey !== editPOC?.eKey
      ) {
        isValid = false
      }
      if (i.PointOfContact.userID === undefined || i.eKey === editPOC?.eKey) {
        isValid = true
      }
    } else {
      isValid = true
    }

    return isValid
  }

  const changeAssignedComponent = (e: { label: string; value: number }) => {
    const majOptions: any[] = initialMajcomOptions
    .filter(
      (item) => item.assignedComponentCode === e.value || e.value === -1
    )
    .map((majcom) => ({
      assignedComponentCode: majcom.assignedComponentCode,
      label: majcom.label,
      squadron: majcom.squadron,
      value: majcom.value,
    }))

  const sectOptions: optionsTypes[] = sections.filter((section) => {
    let containsSquadron = false

    Object.keys(visibleSquadrons).forEach((key) => {
      if (visibleSquadrons[key].length > 0) {
        const formattedSection: string = section?.ShortName?.replace('MPF', 'FSS')

        if (key === 'SectionChief' || key === 'SectionOwner') {
          if (visibleSquadrons[key]
            .some((e) => e.section === formattedSection &&
              majOptions.some((maj) => e.squadron.includes(maj.squadron)))) {
            containsSquadron = true
          }
        }
      }
    })

    return containsSquadron ||
      roleContext?.isCPOwner ||
      roleContext?.isLeadership ||
      roleContext?.isMPFOwner ||
      roleContext?.isMAJCOMOwner ||
      roleContext?.isAssignedComponentOwner
  }).map((section) => {
    const filteredSectOpt = initialSectionOptions.filter((sect) =>
      sect.value === section?.SectionCode
    )[0]

    return {
      label: section?.Section,
      majcom: filteredSectOpt.majcom,
      squadron: filteredSectOpt.squadron,
      value: section?.SectionCode,
    }
  })

  const squadOptions = []
  majOptions.filter((majcom) => majcom.squadron).map((majcom) => {
    majcom.squadron?.map((item) => {
      squadOptions.push({
        label: item,
        value: item
      })
    })
  })

  if (majOptions.length > 1 && majOptions[0].value !== -1) {
    majOptions.unshift(ALL_SELECT_OPTION)
  }

  if (squadOptions.length > 1 && squadOptions[0].value !== -1) {
    squadOptions.unshift(ALL_SELECT_OPTION_STRING)
  }

  setMajcomOptions(majOptions)
  setSectionOptions(sectOptions)
  setSquadronOptions(squadOptions)

  handleChange('AssignedComponent', e.label)
  handleChange('AssignedComponentCode', e.value)
  handleChange('SectionCodes', sectOptions.length === 1 ? [...sectOptions.map((section) => section.value)] ?? '' : [])
  handleChange('SectionCodeOptions', sectOptions.length === 1 ? sectOptions ?? '' : [])
  handleChange('ServicingMAJCOM', majOptions.length === 1 ? majOptions[0].label ?? '' : ALL_SELECT_LABEL)
  handleChange('ServicingMAJCOMCode', majOptions.length === 1 ? majOptions[0].value ?? -1 : ALL_SELECT_VALUE)
  handleChange('Squadron', squadOptions.length === 1 ? squadOptions[0].value ?? '' : ALL_SELECT_VALUE_STRING)

}

  const   changeMajcom = (e: { label: string; value: number }) => {
    const sectOptions: optionsTypes[] = sections.filter((section) => {
      let containsSquadron = false

      Object.keys(visibleSquadrons).forEach((key) => {
        if (visibleSquadrons[key].length > 0) {
          const formattedSection: string = section?.ShortName?.replace('MPF', 'FSS')

          if (key === 'SectionChief' || key === 'SectionOwner') {
            if (visibleSquadrons[key]
              .some((sect) => sect.section === formattedSection &&
                (e.squadron.includes(sect.squadron) || e.value === -1))) {
              containsSquadron = true
            }
          }
        }
      })

      return containsSquadron ||
        roleContext?.isCPOwner ||
        roleContext?.isLeadership ||
        roleContext?.isMPFOwner ||
        roleContext?.isMAJCOMOwner ||
        roleContext?.isAssignedComponentOwner
    }).map((section) => {
      const filteredSectOpt = initialSectionOptions.filter((sect) =>
        sect.value === section?.SectionCode
      )[0]

      return {
        label: section?.Section,
        majcom: filteredSectOpt.majcom,
        squadron: filteredSectOpt.squadron,
        value: section?.SectionCode,
      }
    })

    let squadOptions = []

    if (e?.squadron) {
      e.squadron?.map((item) => {
          squadOptions.push({
            label: item,
            value: item
          })
      })
    } else {
      squadOptions = []
      majcomOptions.map((majcom) => {
          majcom?.squadron?.map((item) => {
            squadOptions.push({
              label: item,
              value: item
            })
          })
        })
    }

    if (squadOptions.length > 1 && squadOptions[0].value !== -1) {
      squadOptions.unshift(ALL_SELECT_OPTION_STRING)
    }

    setSectionOptions(sectOptions)
    setSquadronOptions(squadOptions)

    handleChange('SectionCodes', sectOptions.length === 1 ? [...sectOptions.map((section) => section.value)] ?? '' : [])
    handleChange('SectionCodeOptions', sectOptions.length === 1 ? sectOptions ?? '' : [])
    handleChange('ServicingMAJCOM', e.label)
    handleChange('ServicingMAJCOMCode', e.value)
    handleChange('Squadron', squadOptions.length === 1 ? squadOptions[0].value ?? '' : ALL_SELECT_VALUE_STRING)
  }

  const generateString = (options: any) => {
    return JSON.stringify(options.map((options) => options.label))
  }

  const changeSquadron = (e: any) => {
    const sectOptions: optionsTypes[] = sections.filter((section) => {
      let containsSquadron = false

      Object.keys(visibleSquadrons).forEach((key) => {
        if (visibleSquadrons[key].length > 0) {
          const formattedSection: string = section?.ShortName?.replace('MPF', 'FSS')

          if (key === 'SectionChief' || key === 'SectionOwner') {
            if (visibleSquadrons[key]
              .some((sect) => sect.section === formattedSection &&
                (sect.squadron === e.value || e.value === -1))) {
              containsSquadron = true
            }
          }
        }
      })

      return containsSquadron ||
        roleContext?.isCPOwner ||
        roleContext?.isLeadership ||
        roleContext?.isMPFOwner ||
        roleContext?.isMAJCOMOwner ||
        roleContext?.isAssignedComponentOwner
    }).map((section) => {
      const filteredSectOpt = initialSectionOptions.filter((sect) =>
        sect.value === section?.SectionCode
      )[0]

      return {
        label: section?.Section,
        majcom: filteredSectOpt.majcom,
        squadron: filteredSectOpt.squadron,
        value: section?.SectionCode,
      }
    })

    setSectionOptions(sectOptions)

    handleChange('SectionCodes', sectOptions.length === 1 ? [...sectOptions.map((section) => section.value)] ?? '' : [])
    handleChange('SectionCodeOptions', sectOptions.length === 1 ? sectOptions ?? '' : [])
    handleChange('Squadron', e.value)
  }

  const changeSection = (e: { label: string; value: number }) => {
    handleChange('SectionCodes', sectionOptions.length === 1 ? [sectionOptions[0].value] : [...e.map((section) => section.value)])
    handleChange('SectionCodeOptions', sectionOptions.length === 1 ? [sectionOptions[0]] : e)
  }

  const onClickAlert = async (button: string) => {
    if (button === 'OK') {
      setShowAlert(false)
    } else {
      setShowAlert(false)
    }
  }
  const handleSubmit = async () => {
    let isValid = true
    const isUnique = await validateUniquePOC(selectedValue.id)
    const validations = {
      AssignedComponent: false,
      DutyTitle: false,
      DutyTitleMsg: '',
      MAJCOM: false,
      PhoneNumber: false,
      PhoneNumberMsg: '',
      PointOfContact: false,
      PointOfContactMsg: '',
      Section: false,
    }

    if (selectedValue.id === '') {
      isValid = false
      validations.PointOfContact = true
      validations.PointOfContactMsg = 'Please enter a name or email address'
    }
    if (inputValues.PhoneNumber.length !== 10) {
      isValid = false
      validations.PhoneNumber = true
      validations.PhoneNumberMsg = 'Please enter a valid phone number'
    }
    if (inputValues.DutyTitle === '') {
      isValid = false
      validations.DutyTitle = true
      validations.DutyTitleMsg = 'Please enter a duty title'
    }

    if (!isUnique) {
      isValid = false
      validations.PointOfContact = true
      validations.PointOfContactMsg = 'Name already exists.'
    }
    if (    
    (editPOC?.AssignedComponentCode === null && 
      inputValues.AssignedComponentCode === -1 || 
    editPOC?.AssignedComponentCode === inputValues.AssignedComponentCode) &&
    editPOC?.DutyTitle === inputValues.DutyTitle &&
    editPOC?.IsArchived  === inputValues.IsArchived &&
    (editPOC?.ServicingMAJCOMCode === null && inputValues.ServicingMAJCOMCode === -1 || 
      editPOC?.ServicingMAJCOMCode === inputValues.ServicingMAJCOMCode) &&    
    editPOC?.PhoneNumber === inputValues.PhoneNumber &&
    editPOC?.PointOfContact.properties.defaultDisplay ===
      inputValues.PointOfContact &&
      editPOC?.SectionCodes.sort().join(',') === inputValues?.SectionCodes.sort().join(',') &&
    editPOC?.Title === inputValues.Title) {
      isValid = false
      setShowAlert(true)
    }

    setPOCValidations(validations)
    if (isValid) {
      await savePOC()
    }
  }

  const savePOC = async () => {
    setPageOverlay(true)
    const userdetails = mpfRListsHttp().me()
    const userId = (await userdetails).userId
    const currentDate = new Date()

    const addObj = {
      AssignedComponentCode: generateCode(inputValues.AssignedComponentCode),
      DutyTitle: inputValues.DutyTitle,
      IsArchived: inputValues.IsArchived,
      ItemCreated: currentDate,
      ItemCreatedBy: userId,
      ItemModified: currentDate,
      ItemModifiedBy: userId,
      PhoneNumber: inputValues.PhoneNumber,
      PointOfContact: selectedValue.id,
      Section: generateString(inputValues.SectionCodeOptions),
      SectionCodes: JSON.stringify(inputValues.SectionCodes),
      ServicingMAJCOMCode: generateCode(inputValues.ServicingMAJCOMCode),
      Squadron: inputValues.Squadron,
      Title: selectedValue.mailId,
      eKey: editPOC ? editPOC.eKey : '',
      eTag: editPOC ? editPOC.eTag : '',
    }
    try {
      await addOrUpdatePointOfContact(addObj)
      await fetchPointsOfContact()
      cancel()
      setPageOverlay(false)
    } catch (error) {
      console.error(error)
      cancel()
      setPageOverlay(false)
    }
  }

  const changeUser = async (value: string) => {
    setInputValues((prev) => ({
      ...prev,
      PointOfContact: value,
    }))
    if (value.trim().length > 2) {
      const userList = [...(await mpfWhoHttp().Picker(value.trim()))]
      const userName = userList.map((item) => item.persona)
      setPeopleDropdownNames(userName)
      setPeopleExpand(userList)
      if (selectedValue.title !== value) {
        setSelectedValue({ id: '', mailId: '', title: '' })
      }
    }
  }

  const selectedUser = (value: string) => {
    setInputValues((prev) => ({ ...prev, PointOfContact: value }))
    const id = peopleExpand.find((item) => item.persona === value).rid
    const mail = peopleExpand.find((item) => item.persona === value).email
    setSelectedValue({ id: id, mailId: mail, title: value })
  }

  const handleIsArchived = (e) => {
    setInputValues((prev) => ({
      ...prev,
      IsArchived: e.value,
    }))
  }

  useEffect(() => {
    (async () => {
      if (editPOC?.PointOfContact) {
        await getPoCUserData(
          editPOC?.PointOfContact.properties.defaultDisplay,
          editPOC?.PointOfContact.properties.firstName
        )
      }
    })()
    if (editPOC) {
      setInputValues((prev) => ({
        ...prev,
        SectionCodeOptions: editPOC?.SectionCodes?.map((sectionCode, index) => ({
          label: editPOC?.Section?.split(', ')[index],
          value: sectionCode
        })),
        SectionCodes: editPOC?.SectionCodes?.length > 0 ?
          editPOC.SectionCodes : [],
      }))
    }
  }, [editPOC])

  useEffect(() => {
    const majOptions: any[] = initialMajcomOptions
      .filter(
        (item) => item.assignedComponentCode === inputValues.AssignedComponentCode ||
          inputValues.AssignedComponentCode === -1
      )
      .map((majcom) => ({
        assignedComponentCode: majcom.assignedComponentCode,
        label: majcom.label,
        squadron: majcom.squadron,
        value: majcom.value,
      }))

    const sectOptions: optionsTypes[] = sections.filter((section) => {
      let containsSquadron = false

      Object.keys(visibleSquadrons).forEach((key) => {
        if (visibleSquadrons[key].length > 0) {
          const formattedSection: string = section?.ShortName?.replace('MPF', 'FSS')

          if (key === 'SectionChief' || key === 'SectionOwner') {
            if (visibleSquadrons[key]
              .some((e) => e.section === formattedSection &&
                majOptions.some((maj) => e.squadron.includes(maj.squadron)))) {
              containsSquadron = true
            }
          }
        }
      })

      return containsSquadron ||
        roleContext?.isCPOwner ||
        roleContext?.isLeadership ||
        roleContext?.isMPFOwner ||
        roleContext?.isMAJCOMOwner ||
        roleContext?.isAssignedComponentOwner
    }).map((section) => {
      const filteredSectOpt = initialSectionOptions.filter((sect) =>
        sect.value === section?.SectionCode
      )[0]

      return {
        label: section?.Section,
        majcom: filteredSectOpt.majcom,
        squadron: filteredSectOpt.squadron,
        value: section?.SectionCode,
      }
    })

    const squadOptions = []
    majOptions.filter((majcom) => majcom.squadron).map((majcom) => {
      majcom.squadron?.map((item) => {
        squadOptions.push({
          label: item,
          value: item
        })
      })
    })

    if (majOptions.length > 1 && majOptions[0].value !== -1) {
      majOptions.unshift(ALL_SELECT_OPTION)
    }

    if (squadOptions.length > 1 && squadOptions[0].value !== -1) {
      squadOptions.unshift(ALL_SELECT_OPTION_STRING)
    }


    setMajcomOptions(majOptions)
    setSectionOptions(sectOptions)
    setSquadronOptions(squadOptions)


    if(!editPOC) {
      handleChange('AssignedComponent', assignedComponentOptions.length === 1 ? assignedComponentOptions[0].label ?? '' : ALL_SELECT_LABEL)
      handleChange('AssignedComponentCode', assignedComponentOptions.length === 1 ? assignedComponentOptions[0].value ?? '' : ALL_SELECT_VALUE)
      handleChange('SectionCodes', sectOptions.length === 1 ? [...sectOptions.map((section) => section.value)] ?? '' : [])
      handleChange('SectionCodeOptions', sectOptions.length === 1 ? sectOptions ?? '' : [])
      handleChange('ServicingMAJCOM', majOptions.length === 1 ? majOptions[0].label ?? '' : ALL_SELECT_LABEL)
      handleChange('ServicingMAJCOMCode', majOptions.length === 1 ? majOptions[0].value ?? '' : ALL_SELECT_VALUE)
      handleChange('Squadron', squadOptions.length === 1 ? squadOptions[0].value ?? '' : ALL_SELECT_VALUE_STRING)
    }
  }, [
    assignedComponentOptions,
    initialMajcomOptions,
    initialSectionOptions,
    editPOC
  ])

  const titleRef: any = useRef<any>(null)
  const descriptionRef: any = useRef<any>(null)
  useEffect(() =>{
    const titleElemnt = document.getElementById('pointsofcontact')
    if(titleRef?.current && titleElemnt){
      if(clickedIndex === 0){
        descriptionRef?.current?.scrollIntoView({behavour: 'auto', block: 'end'})
        titleElemnt.focus()
      }else if(clickedIndex === 1){
        descriptionRef?.current?.scrollIntoView({behavour: 'auto', block: 'nearest'})
        titleElemnt.focus()
      }else{
        titleRef?.current?.scrollIntoView(true)
        titleElemnt.focus()
      }
    }
  }, [titleRef, showAddPopup])

  return (
    <div
      className={
        showAddPopup
          ? 'border-radius whitebg bordered15 mt-2'
          : 'settingseditpopup w-100 position-relative  border-top1 mt-2'
      }
      id='scroll'
    >
      {showAlert && (
        <Alert
          alerttextclass='poppins-semibold font-13 text-center'
          btn1className='btn btn btn-sm font-12 poppins-semibold btn-primary whitetext border-radius text-uppercase'
          btn1iconclassNmae='icon-checked font-12 pe-1'
          btn2classNmae='btn btn btn-border1 darktext btn-sm poppins-semibold font-12 border-radius text-uppercase'
          btn2iconclassNmae='icon-close color-primary font-12 pe-1'
          cancel='Cancel'
          className='alert-info'
          message={NO_CHANGE_MESSAGE}
          onClick={onClickAlert}
          yes='OK'
        />
      )}
      {showPageOverlay && <PageOverlayBusy />}
      {showAddPopup && (
        <div className='p-3 border-bottom4'>
          <h4
            aria-label='Add People'
            className='m-0 p-0 d-inline-block font-15 poppins-semibold color-primary text-uppercase'
            tabIndex={0}
          >
            Add People
          </h4>
        </div>
      )}
      <div className='px-2 py-1'>
        <div className='row'>
          <div
            className={
              showAddPopup
                ? 'col-sm-12 col-lg-4 mb-2'
                : 'col-sm-12 col-lg-4 mb-2'
            }
            ref={titleRef}
          >
            <InputText
              changeHandler={(e: any) => changeUser(e.target.value)}
              className='form-lg'
              data={peopleDropdownNames}
              errorMessage={POCValidations.PointOfContact}
              formClassName=' d-flex flex-column p-relative customautocomplete'
              info='Points of Contact'
              infoClassName='tool-tip tooltip-bottom font-12 sourcesanspro'
              infoIcon='icon-info color-primary'
              inputProps={{
                className: 'poppins-medium font-12 title-color2 mb-1',
                id: 'pointsofcontact',
                maxLength: MAX_LENGTHS.TWO_HUNDRED_FIFTY,
                name: 'Points of Contact ',
                placeholder: 'Enter Name or Email Address',
              }}
              isInfo
              isMandatory
              label='Points of Contact'
              msg={POCValidations.PointOfContactMsg}
              onSelect={selectedUser}
              type='peopel-picker'
              value={inputValues.PointOfContact}
            />
          </div>
          <div
            className={
              showAddPopup
                ? 'col-sm-12 col-lg-4 mb-2'
                : 'col-sm-12 col-lg-4 mb-2'
            }
          >
            <InputText
              changeHandler={(e: any) =>
                handleChangeNumber('PhoneNumber', e.target.value)
              }
              className='form-lg'
              errorMessage={POCValidations.PhoneNumber}
              formClassName=' d-flex flex-column'
              info='Phone Number'
              infoClassName='tool-tip tooltip-bottom font-12 sourcesanspro'
              infoIcon='icon-info color-primary'
              inputProps={{
                className: 'poppins-medium font-12 title-color2 mb-1',
                id: 'PhoneNumber',
                maxLength: MAX_LENGTHS.TEN_DIGITS,
                name: 'Phone Number',
                placeholder: 'Enter Phone Number',
                value: inputValues.PhoneNumber,
              }}
              isInfo
              isMandatory
              label='Phone Number'
              msg={POCValidations.PhoneNumberMsg}
              type='tel'
              value={inputValues.PhoneNumber}
            />
          </div>
          <div
            className={
              showAddPopup
                ? 'col-sm-12 col-lg-4 mb-2'
                : 'col-sm-12 col-lg-4 mb-2'
            }
          >
            <InputText
              changeHandler={(e: any) =>
                handleChange('DutyTitle', e.target.value)
              }
              errorMessage={POCValidations.DutyTitle}
              formClassName='d-flex flex-column'
              info='Duty Title'
              infoClassName='tool-tip tooltip-top font-12 sourcesanspro'
              infoIcon='icon-info color-primary'
              inputProps={{
                className: 'poppins-medium font-12 title-color2 mb-1',
                id: ' DutyTitle ',
                name: 'Duty Title',
                placeholder: 'Enter Title',
                value: inputValues.DutyTitle,
              }}
              isInfo
              isMandatory
              label='Duty Title '
              msg={POCValidations.DutyTitleMsg}
              value={inputValues.DutyTitle}
            />
          </div>
          <div
            className={
              showAddPopup
                ? 'col-sm-12 col-lg-4 mb-2'
                : 'col-sm-12 col-lg-4 mb-2'
            }
            ref={descriptionRef}
          >
            <CustomSelect
              className='form-lg w-100 sourcesanspro font-13 customselect'
              error={POCValidations.AssignedComponent}
              formClassName='form-vertical text-nowrap poppins-semibold font-11'
              id='AssignedComponent'
              info='Assigned Component '
              infoClassName='tool-tip tooltip-top font-12 sourcesanspro'
              infoIcon='icon-info color-primary'
              inputProps={{
                className: 'mb-1 font-12 poppins-medium title-color',
              }}
              isInfo
              label='AssignedComponent'
              menuPlacement='bottom'
              menuPortalTarget={document.body}
              menuPosition={'fixed'}
              name='Assigned Component'
              onChange={changeAssignedComponent}
              options={assignedComponentOptions}
              value={inputValues?.AssignedComponentCode}
            />
          </div>

          <div
            className={
              showAddPopup
                ? 'col-sm-12 col-lg-4 mb-2'
                : 'col-sm-12 col-lg-4 mb-2'
            }
          >
            <CustomSelect
              className='form-lg w-100 sourcesanspro font-13 customselect'
              disabled={roleContext.isCPOwner || 
                roleContext.isAssignedComponentOwner}
              error={POCValidations.MAJCOM}
              formClassName='form-vertical text-nowrap poppins-semibold font-11'
              id='ServicingMAJCOM'
              info='Servicing MAJCOM'
              infoClassName='tool-tip tooltip-top font-12 sourcesanspro'
              infoIcon='icon-info color-primary'
              inputProps={{
                className: 'mb-1 font-12 poppins-medium title-color',
              }}
              isInfo
              label='Servicing MAJCOM'
              menuPlacement='bottom'
              menuPortalTarget={document.body}
              menuPosition={'fixed'}
              name='Servicing MAJCOM'
              onChange={changeMajcom}
              options={majcomOptions}
              value={inputValues.ServicingMAJCOMCode}
            />
          </div>
          <div
            className={
              showAddPopup
                ? 'col-sm-12 col-lg-4 mb-2'
                : 'col-sm-12 col-lg-4 mb-2'
            }
          >
            <CustomSelect
              className='form-lg w-100 sourcesanspro font-13 customselect'
              disabled={roleContext.isCPOwner || 
                roleContext.isAssignedComponentOwner || 
                roleContext.isMAJCOMOwner}
              error={POCValidations.MAJCOM}
              formClassName='form-vertical text-nowrap poppins-semibold font-11'
              id='ServicingOrganization'
              info='Servicing Organization'
              infoClassName='tool-tip tooltip-top font-12 sourcesanspro'
              infoIcon='icon-info color-primary'
              inputProps={{
                className: 'mb-1 font-12 poppins-medium title-color',
              }}
              isInfo
              label='Servicing Organization'
              menuPlacement='bottom'
              menuPortalTarget={document.body}
              menuPosition={'fixed'}
              name='Servicing MAJCOM'
              onChange={changeSquadron}
              options={squadronOptions}
              value={inputValues.Squadron}
            />
          </div>
          <div
            className={
              showAddPopup
                ? 'col-sm-12 col-lg-4 mb-2'
                : 'col-sm-12 col-lg-4 mb-2'
            }
          >
            <CustomSelect
              className='form-lg w-100 sourcesanspro font-13 customselect'
              error={POCValidations.Section}
              formClassName='form-vertical text-nowrap poppins-semibold font-11'
              id='Section'
              info='Section'
              infoClassName='tool-tip tooltip-top font-12 sourcesanspro'
              infoIcon='icon-info color-primary'
              inputProps={{
                className: 'mb-1 font-12 poppins-medium title-color',
              }}
              isInfo
              isMulti
              label='Section'
              menuPlacement='bottom'
              menuPortalTarget={document.body}
              menuPosition={'fixed'}
              name='Section'
              onChange={changeSection}
              options={sectionOptions}
              value={inputValues.SectionCodeOptions}
            />
          </div>
          {!showAddPopup && (
            <div className='col-sm-12 col-lg-4 mb-2'>
              <CustomSelect
                className='form-lg w-100 sourcesanspro font-13 customselect'
                formClassName='form-vertical text-nowrap poppins-semibold font-11'
                id='IsArchived'
                info='IsArchived'
                infoClassName='tool-tip tooltip-top font-12 sourcesanspro'
                infoIcon='icon-info color-primary'
                inputProps={{
                  className: 'mb-1 font-12 poppins-medium title-color',
                }}
                isInfo
                label='Is Archived'             
                menuPortalTarget={document.body}
                menuPosition={'fixed'}
                name='Is Archived'
                onChange={handleIsArchived}
                options={IsArchived}
                value={inputValues.IsArchived}
              />
            </div>
          )}
        </div>
        <div className='d-flex py-1 flex-wrap'>
          <div className='ms-auto settingsbtns d-flex'>
            {showAddPopup && (
              <>
                <Buttons
                  className='btn-border-radius3 py-1 px-3 btn-bgcolor9  ms-2 whitetext poppins-bold font-12 text-uppercase btn-xs'
                  icon='icon-save font-11 pe-1'
                  label='Save'
                  onClick={handleSubmit}
                  type='button'
                />
                <Buttons
                  className='py-1 px-3 btn-border-radius3 btn-border1 ms-2 poppins-bold font-12 text-uppercase btn-xs'
                  icon='icon-close color-primary font-9 pe-1'
                  label='Cancel'
                  onClick={() => {
                    filtersvalue(!showAddPopup) 
                  }}
                  type='button'
                />{' '}
              </>
            )}
            {!showAddPopup && (
              <>
                <Buttons
                  className='btn-border-radius3 py-1 px-3 btn-bgcolor9  ms-2 whitetext poppins-bold font-12 text-uppercase btn-xs'
                  icon='icon-update font-11 pe-1'
                  label='Update'
                  onClick={handleSubmit}
                  type='button'
                />
                <Buttons
                  className='py-1 px-3 btn-border-radius3  btn-border1  ms-2 poppins-bold font-12 text-uppercase btn-xs'
                  icon='icon-close color-primary font-9 pe-1'
                  label='Cancel'
                  onClick={() => {
                    cancel()
                  }}
                  type='button'
                />
              </>
            )}
          </div>
        </div>
      </div>
    </div>
  )
}
export default AddEditView
